// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"64ef99d6","885":"47d51977"}[chunkId] + ".chunk.js";
};